<mat-dialog-content class="customer-dialog">
    <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Protocol Code</mat-label>
      <input matInput [(ngModel)]="prHdCode" (keyup)="retriveProtocol()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Protocol Name</mat-label>
      <input matInput [(ngModel)]="prHdName" (keyup)="retriveProtocol()">
    </mat-form-field>

  </div>
  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 20%;">Protocol Code</th>
            <th style="width: 120%;">Protocol Name</th>
            <th style="width: 20%;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pro of protocolHD; let i = index">
            <td data-column="Protocol ID">{{pro.prHdCode}}</td>
            <td data-column="Protocol Name">{{pro.prHdName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectProtocol(pro)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </mat-dialog-content>

